<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">

      <p-panel header="{{ 'ESTADOS.LBL_CONFIGBOTONESESTADO' | translate}}">
        <h3>{{estado ? estado.nombre : ''}}</h3>

        <form [formGroup]="formulario" (ngSubmit)="guardar()" id="formProductoDesembolso" name="formProductoDesembolso" *ngIf="formulario">
          <div class="grid col-nopad form-group">

            <!-- Campos -->
            <!-- Lista Botones -->
            <div class="col-12 md:col-8">
              <div class="div-form mt-1">
                <label for="idBoton">* {{ 'ESTADOS.LBL_LISTADOBOTON' | translate }}</label>
                <p-dropdown disableTab  id="idBoton" name="idBoton" [options]="botonesFiltrados"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            required="true" class="form-group"
                            formControlName="idBoton"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idBoton.invalid">
                  {{ 'ESTADOS.LBL_LISTADOBOTON' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>

              </div>
            </div>

            <!-- Guardar -->
            <div class="col-12 md:col-4 mt-3">
              <div *ngIf="!guardando">
                <button class="form-group" pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
              </div>
              <div class="form-group text-center" *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
              </div>
            </div>

          </div>
        </form>

        <hr>

        <!-- Tabla -->
        <div class="grid col-nopad">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas" [loading]="cargandoTabla"
                     [rows]="10" [value]="estadosBotones" [paginator]="true"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                      class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.codigoBoton}}</td>
                  <td>{{row.nombreBoton}}</td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                              title="{{'BTN_ELIMINAR' | translate}}"
                              pButton (click)="eliminar(row)"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="estados-botones">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

